var _defs, _path, _polygon, _path2, _polyline, _polyline2, _polyline3, _line, _polyline4, _line2, _line3, _polyline5, _line4, _polyline6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection128(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.73,238A15.27,15.27,0,0,1,45.5,222.77V67.9L102,18h93.26A15.27,15.27,0,0,1,210.5,33.23V222.77A15.23,15.23,0,0,1,195.27,238Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.91,142.64a12.85,12.85,0,1,1-12.85-12.85A12.85,12.85,0,0,1,140.91,142.64Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.55 93.69 151.48 84.82 128.78 75.85 128.78 105.83"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "137.8 210.04 137.8 184.11 118.33 184.11 118.33 210.04"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "166.51 126.03 128.73 105.79 89.61 126.03"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 101.37,
    y1: 121.02,
    x2: 101.37,
    y2: 210.04
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "100.91 160.45 63.23 160.45 63.23 146.04 100.91 146.04"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.62,
    y1: 175.21,
    x2: 85.62,
    y2: 185.83
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.02,
    y1: 121.77,
    x2: 155.02,
    y2: 210.04
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "155.22 160.45 192.9 160.45 192.9 146.04 155.22 146.04"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 170.51,
    y1: 175.21,
    x2: 170.51,
    y2: 185.83
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "185.23 161.45 185.23 210.04 70.91 210.04 70.91 161.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection128);
export default __webpack_public_path__ + "static/media/section128.e1ca8432870544733e864e6d5ba4d710.svg";
export { ForwardRef as ReactComponent };